import React from 'react';
import './Congrat.css';
import {Modal} from 'react-bootstrap'

const MakeDeposit = 
({text, show, closePop, url, lang}) => {

    const linkUrl = url === 'acy' ? 'https://secure.cloudhubpanel.com/#/fund-manager/deposite-funds' :
        'https://secureportal.cloudhubpanel.com/#/fund-manager/deposite-funds';

    return (

        <Modal show={show} onHide={() => closePop('deposit')} size="lg" centered className={`deposit-modal my-modal ${lang}`}>
            <Modal.Header closeButton={true}>
            </Modal.Header>
            <Modal.Body>
                <h3>{text.title}</h3>
                <p>{text.p1}</p>
                <p>{text.p2}</p>
                
                <a href={linkUrl} className="modal-btn">{text.button}</a>
            </Modal.Body>
        </Modal>

    );
};
export default MakeDeposit
